import { useSelector } from 'react-redux'

import type { AppState } from '@/types'

/**
 * True while the artboard is off and nothing on it can be edited: the socket
 * dropped, a commit was refused, the assistant is working or the activity
 * history is open. The flag is worked out in the artboard reducer.
 */
export const useArtBoardDisabled = () =>
  useSelector<AppState, boolean>(({ artboard }) => artboard.isDisabled)
